import { render, staticRenderFns } from "./VisorImagenes.vue?vue&type=template&id=78bd1de8"
import script from "./VisorImagenes.vue?vue&type=script&lang=js"
export * from "./VisorImagenes.vue?vue&type=script&lang=js"
import style0 from "./VisorImagenes.vue?vue&type=style&index=0&id=78bd1de8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports